<div class="justified-container top-actions">
  <div class="flex action-buttons-wrapper">
    @for (leftButton of leftGroupButtons; track leftButton) {
      @switch (leftButton.type) {
        @case (ActionButtonType.Primary) {
          <ng-container *ngTemplateOutlet='regularButtonTmpl; context: {regularButton: leftButton}'></ng-container>
        }
        @case (ActionButtonType.Secondary) {
          <ng-container *ngTemplateOutlet='regularButtonTmpl; context: {regularButton: leftButton}'></ng-container>
        }
        @case (ActionButtonType.MenuButtonPrimary) {
          <ng-container *ngTemplateOutlet='menuButtonsTmpl; context: {menuButton: leftButton}'></ng-container>
        }
        @case (ActionButtonType.MenuButtonSecondary) {
          <ng-container *ngTemplateOutlet='menuButtonsTmpl; context: {menuButton: leftButton}'></ng-container>
        }
        @case (ActionButtonType.Custom) {
          <ng-container *ngTemplateOutlet='leftButton.customTemplate; context: {leftButton: leftButton}'></ng-container>
        }
      }
    }
  </div>
  <div class="flex action-buttons-wrapper">
    @for (rightButton of rightGroupButtons; track rightButton) {
      @switch (rightButton.type) {
        @case (ActionButtonType.Primary) {
          <ng-container *ngTemplateOutlet='regularButtonTmpl; context: {regularButton: rightButton}'></ng-container>
        }
        @case (ActionButtonType.Secondary) {
          <ng-container *ngTemplateOutlet='regularButtonTmpl; context: {regularButton: rightButton}'></ng-container>
        }
        @case (ActionButtonType.MenuButtonPrimary) {
          <ng-container *ngTemplateOutlet='menuButtonsTmpl; context: {menuButton: rightButton}'></ng-container>
        }
        @case (ActionButtonType.MenuButton) {
          <ng-container *ngTemplateOutlet='menuButtonsTmpl; context: {menuButton: rightButton}'></ng-container>
        }
        @case (ActionButtonType.Custom) {
          <ng-container *ngTemplateOutlet='rightButton.customTemplate; context: {rightButton: rightButton}'></ng-container>
        }
      }
    }

    @if (!hideColumnSearchFunctionality) {
      <ng-container *ngTemplateOutlet='columnSearchFieldsToggleTmpl'></ng-container>
    }

    @if (showColumnSelection) {
      <ng-container *ngTemplateOutlet='columnSelectionTmpl'></ng-container>
    }
  </div>
</div>
<div class="line-separator actions-separator" [class.margin-bottom-10]="!columnSearchActive"></div>

<ng-template #regularButtonTmpl let-regularButton='regularButton'>
  @if (!regularButton.isHidden) {
    @if (regularButton.url) {
      <button type="button" id="{{ regularButton.id }}" class="btn" [ngClass]="{ 'btn-primary fiori3-btn-primary': regularButton.type === ActionButtonType.Primary, 'btn-secondary fiori3-btn-secondary': regularButton.type === ActionButtonType.Secondary }"
      routerLink="/{{regularButton.url}}" [disabled]='regularButton.isDisabled'>{{regularButton.key | translate}}</button>
    }
    @if (!regularButton.url) {
      <button type="button" id="{{ regularButton.id }}" class="btn" [ngClass]="{ 'btn-primary fiori3-btn-primary': regularButton.type === ActionButtonType.Primary, 'btn-secondary fiori3-btn-secondary': regularButton.type === ActionButtonType.Secondary }"
      (click)="regularButton.click()" [disabled]='regularButton.isDisabled'>{{regularButton.key | translate}}</button>
    }
  }
</ng-template>

<ng-template #menuButtonsTmpl let-menuButton='menuButton'>
  <cpq-button-menu id="{{ menuButton.id }}" [items]="menuButton.actions" [buttonText]="menuButton.key" [isDisabled]="menuButton.isDisabled" [btnStyleClass]="{'btn-primary fiori3-btn-primary': menuButton.type === ActionButtonType.MenuButtonPrimary, 'btn-secondary fiori3-btn-secondary': menuButton.type === ActionButtonType.MenuButtonSecondary }" [iconStyleClass]="'dropdown-icon'"></cpq-button-menu>
</ng-template>

<ng-template #columnSelectionTmpl>
  <button type="button" id="columnSettingsToggle" class="btn fiori3-icon-button float-right cog-button" (click)="selectColumns()" [matTooltip]="'ColumnSelection.ToggleModal' | translate" matTooltipPosition="above" matTooltipClass="action-button-toggle" matTooltipShowDelay="100">
    <span class="sap-icon">&#xe0a6;</span>
  </button>
</ng-template>

<ng-template #columnSearchFieldsToggleTmpl>
  <button type="button" id="columnSearchToggle" class="btn fiori3-icon-button float-right column-search-toggle" [class.active]="columnSearchActive" (click)="toggleColumnSearchFields()" [matTooltip]="'ColumnSearch.ToggleTooltip' | translate" matTooltipPosition="above" matTooltipClass="action-button-toggle" matTooltipShowDelay="100">
    <span class="sap-icon">&#xe076;</span>
  </button>
</ng-template>

